import React, { Suspense, useState, useEffect, useRef } from "react";
import SideMenu from "./menu/menu";
// import SideMenu from "./menu/index";
import { Outlet, useLocation } from 'react-router-dom';
import ErrorBoundary from "./error-boundary";
import $ from "jquery"
import { isPast } from "date-fns"
import { store } from '../redux/store'
import ClearCache from "./ClearCache";
import { Loader } from "./react-overlay-loader";
import { authUserUsingToken } from "../redux/user/user.actions"
import { startSession, logSession, startActiveSession, setActiveTimeZero, DEFAULT_EVENTS, setViewSessionTimeZero, startViewSession } from "../redux/event/event.actions"
import { renderMaintenanceInfo } from '../maintenance'
import { config } from '../helpers'
import ReactGA from 'react-ga4';
function App() {
  let location = useLocation();

  const [prevLocation, setPrevLocation] = useState("")

  const [position, setPosition] =  useState({ x: 0, y: 0 });
  const isDragging = useRef(false);
  const hasMoved = useRef(false);
  const offset = useRef({ x: 0, y: 0 });
  const draggableElement = useRef(null);

  let user = store.getState().user
  let userName = ""
  if (user.firstName) {
    userName = user.firstName
  }


  useEffect(() => {
    if (process.env.NODE_ENV !== "development") {

      DEFAULT_EVENTS.map(function (num) {
        return window.addEventListener(num, e => { setActiveTimeZero() }, false)
      });

      window.addEventListener("focus", e => { setViewSessionTimeZero(); }, false)
      window.addEventListener("load", e => { startSession(); startActiveSession(); }, false)

    }

    /* No token */
    window.addEventListener('storage', e => {

      if (e.key === config.bbToken && e.oldValue && !e.newValue) {// logout automatically in all open tabs
        store.dispatch({ type: "UNAUTH_USER" });
      }
      else if (e.key === config.bbToken && e.newValue && !e.oldValue) {  // login automatically in all open tabs
        store.dispatch(authUserUsingToken("/login", ""))
      }

    });

    const handleClick = (event) => {
      const el = event.target;
      const excludeButton = ["next", "back"], includeButton = ["btn", "bb-button", "btn-trackable"], text = el.innerText.toLowerCase()
      let originalText = el.getAttribute("data-original-text")

      if (!excludeButton.includes(text) && (el.tagName === "BUTTON" || includeButton.some(className => el.classList.contains(className)))) {
        ReactGA.event(`button_click`, {
          action: 'Click',
          label: originalText ? originalText : (el.innerText || el.title)
        });
      }
    };

    
    if (process.env.NODE_ENV !== "development") document.addEventListener("click", handleClick);
    return () => {
      if (process.env.NODE_ENV !== "development") document.removeEventListener("click", handleClick);
    }

  }, [])

  /* Location change effect */
  useEffect(() => {
    let user = store.getState().user;
    if (process.env.NODE_ENV !== "development") {

      ReactGA.initialize(config.GACode);
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });

      setPrevLocation(location.pathname + location.search)
      let maintenance = user.maintenance || false;
      let localMaintenance = localStorage.getItem("bb-maintenance");
      let mId = false;
      if (localMaintenance) {
        mId = localMaintenance.replace("ack~", "");
      }

      // eslint-disable-next-line
      if (maintenance && maintenance.scheduled && maintenance.id && !isPast(new Date(maintenance.date + "T" + maintenance.start_time + ":00.000+10:00")) && (mId != maintenance.id)) {
        renderMaintenanceInfo(maintenance);
      }
    }

  }, [location]);

  /* Location previous change effect */
  useEffect(() => {

    if (process.env.NODE_ENV !== "development") {

      window.addEventListener("blur", e => { startViewSession(prevLocation, store) }, false)
      window.addEventListener("beforeunload", (e) => { e.stopImmediatePropagation(); store.dispatch(logSession(prevLocation, true)); }, false)
    }
  }, [prevLocation]);


  useEffect(() => {

    
    if (draggableElement.current) {
      const onMouseDown = (e) => {
        isDragging.current = true;
        hasMoved.current = false; 
        offset.current = {
          x: e.clientX - position.x,
          y: e.clientY - position.y,
        };
      };

      const onMouseMove = (e) => {
        if (isDragging.current) {
          hasMoved.current = true; 
          const newX = e.clientX - offset.current.x;
          const newY = e.clientY - offset.current.y;
          setPosition({ x: newX, y: newY });
          draggableElement.current.style.transform = `translate(${newX}px, ${newY}px)`;
        }
      };

      const onMouseUp = () => {
        isDragging.current = false;
      };

      const onClick = (e) => {
        if (hasMoved.current) {          
          e.preventDefault();
          e.stopPropagation();
          return;
        }
      };

      draggableElement.current.addEventListener("mousedown", onMouseDown);
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
      draggableElement.current.addEventListener("click", onClick);

      return () => {
        draggableElement.current.removeEventListener("mousedown", onMouseDown);
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        draggableElement.current.removeEventListener("click", onClick);
      };
    }
  }, [position]);


  return (
    <React.Fragment>
      <ClearCache auto={true} storageKey="BUDDY-APP-VERSION">

        {// eslint-disable-next-line
          ({ }) => (
            //(!loading && !isLatestVersion) && notify("Reloading Buddy to apply the latest updates.", "s")
            <></>
          )}
      </ClearCache>
      <div className="bb-container">
        <SideMenu location={location} />
        <div id="bb-container-main" className="bb-container-main">
          <ErrorBoundary>
            <Suspense fallback={<Loader containerStyle={{ backgroundColor: "transparent" }} loading={true} fullPage text="Loading..." />}>
              <Outlet />
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>

    </React.Fragment>
  );

}


export default (App);
